module.exports = __webpack_public_path__ + "static/media/placeholder-header.81909817.png";